import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetcher, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/UserController/CreateUserController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import UserService from "../../../Setup/controller/UserController/UserController";
import LocationService from "../../../Setup/controller/LocationController/LocationController";
import MultiSelectDropdown from "./MultiSelectDropdown";
function CreateUser({ user, onClose, onSuccess, roles, teams }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        Email: '', DisplayName: '', UserPassword: '', ConfirmPassword: '', RoleID: "0", TeamID: "0",
        RateMethod: '1', ExchangePassword: '', Rate: '0.00', Cost: '0.00', AdditionalRate: '0.00', AdditionalCost: '0.00',
        WeekendRate: '0.00', WeekendCost: '0.00', UserID: "0"
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const [LocationList, setLocationData] = useState([]);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [selectedLocations, setSelectedLocations] = useState([]);
    useEffect(() => {
        fetchLocations();
        if (user) {
            setFormData({
                Email: user.Email || '', DisplayName: user.DisplayName || '', UserPassword: user.UserPassword, ConfirmPassword: user.UserPassword,
                RoleID: user.RoleID || "0", TeamID: user.TeamID || "0", RateMethod: user.RateMethod || '1',
                ExchangePassword: user.ExchangePassword || '', Rate: user.Rate || '0.00', Cost: user.Cost || '0.00',
                AdditionalRate: user.AdditionalRate || '0.00', AdditionalCost: user.AdditionalCost || '0.00',
                WeekendRate: user.WeekendRate || '0.00', WeekendCost: user.WeekendCost || '0.00',
                UserName: user.UserName, UserID: user.UserID
            });
            setErrors({});
          //  setSelectedLocations(user.DepotID);
            
        } else {
            setFormData({
                Email: '', DisplayName: '', UserPassword: '', ConfirmPassword: '', RoleID: "0", TeamID: "0",
                RateMethod: '1', ExchangePassword: '', Rate: '0.00', Cost: '0.00', AdditionalRate: '0.00', AdditionalCost: '0.00',
                WeekendRate: '0.00', WeekendCost: '0.00', UserName: '', UserID: "0"
            });
            setErrors({});
        }
    }, [user, roles, teams]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const checkEmailExistence = async (redirectCallback, email) => {
        try {
            const response = await UserService.IsEmailExist(redirectCallback, email);
            return response.length;
        } catch (error) {
            console.error('Error checking email existence:', error);
            return false;
        }
    };
    const checkCompanyEmailExistence = async (redirectCallback, email) => {
        try {
            const response = await UserService.IsCompanyEmailExist(redirectCallback, email);
            return response.length;
        } catch (error) {
            console.error('Error checking email existence:', error);
            return false;
        }
    };
    const fetchLocations = async () => {
        try {
            const listOfLocations = await LocationService.GetAllLocations();
            setLocationData(listOfLocations);
            if (user && user.DepotID) {
                const matchedDepots = listOfLocations
                    .filter(loc => user.DepotID.includes(loc.PK_Location_ID))
                    .map(loc => (loc.PK_Location_ID));
                
                setSelectedLocations(matchedDepots);
            }
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    const handleFormSubmit = async (event) => {
        debugger;
        event.preventDefault();
        if (user) {
            formData.UserID = user.UserID;
        } else {
            formData.UserID = 0;
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const emailExists = await checkEmailExistence(redirectCallback, formData.Email);
            const companyEmailExists = await checkCompanyEmailExistence(redirectCallback, formData.Email);

            if (emailExists > 0) {
                setErrors(prevErrors => ({ ...prevErrors, Email: 'Email already exists' }));
                return;
            }
            else if (companyEmailExists > 0) {
                setErrors(prevErrors => ({ ...prevErrors, Email: 'Email already exists' }));
                return;
            }
        }
        const formDataWithDepots = {
            formData: formData,
            DepotList: selectedLocations

        };

        const postData = await handleSubmit(event, formDataWithDepots, setFormData, setErrors);

        if (postData === "User added successfully") {
            onSuccess();
            onClose();
        }
        else {

        }
    };
    const userOptions = LocationList.map(location => ({
        value: location.PK_Location_ID,
        label: location.vc_Name,
    }));
    const handleLocationChange = async (selectedValues) => {
        setSelectedLocations(selectedValues); // selectedValues are now just IDs (numbers)
      };
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="createUserModal" tabIndex="-1" aria-labelledby="largeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{user ? "Edit User" : "Add User"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="Email" className="col-sm-2 col-form-label">Email</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Email" value={formData.Email} 
                                        readOnly={!!user} onChange={(e) => setFormData(prev => ({ ...prev, Email: e.target.value.toLowerCase() }))}  />
                                        {errors.Email && <div style={{ color: 'red' }}>{errors.Email}</div>}
                                    </div>
                                    <label htmlFor="RateMethod" className="col-sm-2 col-form-label">{t('chargeMethod')}</label>
                                    <div className="col-sm-4">
                                        <select name="RateMethod" className='form-control' value={formData.RateMethod} onChange={handleFieldChange}>
                                            <option value="">Select Charge Method</option>
                                            <option value="1">Per Hour</option>
                                            <option value="2">Per Minute</option>
                                            <option value="3">Per Day</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="UserName" className="col-sm-2 col-form-label">User Name</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="UserName" value={formData.UserName} readOnly={!!user} onChange={(e) => setFormData(prev => ({ ...prev, UserName: e.target.value.toLowerCase() }))} />
                                        {errors.UserName && <div style={{ color: 'red' }}>{errors.UserName}</div>}
                                    </div>
                                    <label htmlFor="Rate" className="col-sm-2 col-form-label">{t('basicRate')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Rate" value={formData.Rate} onChange={handleFieldChange} />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="UserPassword" className="col-sm-2 col-form-label">{t('password')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="UserPassword" value={formData.UserPassword} onChange={handleFieldChange} />
                                        {errors.UserPassword && <div style={{ color: 'red' }}>{errors.UserPassword}</div>}
                                    </div>
                                    <label htmlFor="Cost" className="col-sm-2 col-form-label">{t('basicRateCost')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Cost" value={formData.Cost} onChange={handleFieldChange} />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="ConfirmPassword" className="col-sm-2 col-form-label">{t('confirmPassword')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="ConfirmPassword" value={formData.ConfirmPassword} onChange={handleFieldChange} />
                                        {errors.ConfirmPassword && <div style={{ color: 'red' }}>{errors.ConfirmPassword}</div>}
                                    </div>
                                    <label htmlFor="AdditionalRate" className="col-sm-2 col-form-label">{t('doubleTime')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="AdditionalRate" value={formData.AdditionalRate} onChange={handleFieldChange} />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="DisplayName" className="col-sm-2 col-form-label">{t('displayName')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="DisplayName" value={formData.DisplayName} onChange={handleFieldChange} />
                                        {errors.DisplayName && <div style={{ color: 'red' }}>{errors.DisplayName}</div>}
                                    </div>
                                    <label htmlFor="AdditionalCost" className="col-sm-2 col-form-label">{t('doubleTimeCost')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="AdditionalCost" value={formData.AdditionalCost} onChange={handleFieldChange} />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="RoleID" className="col-sm-2 col-form-label">{t('role')}</label>
                                    <div className="col-sm-4">
                                        <select name="RoleID" className='form-control' value={formData.RoleID} onChange={handleFieldChange}>
                                            <option value="0">Select Role</option>
                                            {roles.map((role) => (
                                                <option key={role.RolesId} value={role.RolesId}>
                                                    {role.RoleName}
                                                </option>
                                            ))}
                                        </select>

                                        {errors.RoleID && <div style={{ color: 'red' }}>{errors.RoleID}</div>}
                                    </div>
                                    <label htmlFor="WeekendRate" className="col-sm-2 col-form-label">{t('overtime')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="WeekendRate" value={formData.WeekendRate} onChange={handleFieldChange} />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="TeamID" className="col-sm-2 col-form-label">{t('team')}</label>
                                    <div className="col-sm-4">
                                        <select name="TeamID" className='form-control' value={formData.TeamID} onChange={handleFieldChange}>
                                            <option value="0">Select Team</option>
                                            {teams.map((team) => (
                                                <option key={team.PK_Team_ID} value={team.PK_Team_ID}>
                                                    {team.vc_Name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.TeamID && <div style={{ color: 'red' }}>{errors.TeamID}</div>}
                                    </div>
                                    <label htmlFor="WeekendCost" className="col-sm-2 col-form-label">{t('overtimeCost')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="WeekendCost" value={formData.WeekendCost} onChange={handleFieldChange} />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="TeamID" className="col-sm-2 col-form-label">Select Depot</label>
                                    <div className="col-sm-4">
                                        <MultiSelectDropdown
                                            options={userOptions}
                                            selectedOptions={selectedLocations}
                                            onChange={handleLocationChange} // Pass handler here
                                        />
                                    </div>

                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {user ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateUser;
